import { useDispatch } from 'react-redux';
import { selectUsers, setUserInfo } from '@store/slices/users/usersSlice';
import { useLogOutMutation } from '@store/rtk/auth';
import { getTabId, sessionSetter } from '@utils/storage';
import { AUTH_CHANNEL } from '@utils/authConfig';
import { logger } from '@utils/logger';
import { useUnlockAllUserLocksMutation } from '@store/rtk/rides';
import { useAppSelector } from '@store/hooks';

export const useLogout = () => {
  const [logOutMutation] = useLogOutMutation();
  const [unlockAllUserLocks] = useUnlockAllUserLocksMutation();
  const dispatch = useDispatch();
  const { userInfo } = useAppSelector(selectUsers);

  const logoutSystem = async () => {
    const tabId = getTabId();

    try {
      await unlockAllUserLocks({ userId: userInfo.id }).unwrap();
      await logOutMutation({}).unwrap();
    } catch (e) {
      logger.warn('Server logout failed, clearing local session.');
    }

    dispatch(setUserInfo(null));
    sessionSetter.clearAll();
    window.name = '';

    const channel = new BroadcastChannel(AUTH_CHANNEL);
    channel.postMessage({ type: 'logout', from: tabId });
    channel.close();

    window.location.href = '/authorization/login';
  };

  return { logoutSystem };
};
